export default __webpack_public_path__ + "static/kacper-raciborski-ebee86b8b7b70c94c5f207e2053e88d5.jpg";